module.exports = __webpack_public_path__ + "static/media/allen_williams.f123cd9b.jpeg";